<template>
  <div class="sign-container">
    <div class="personalMainHead">
      <PersonalHead
        type="initiation_single"
        titleName="批量签署"
        titleNamePrefix="签约管理 > "
      ></PersonalHead>
    </div>
    <div class="signature signature2">
      <div class="mainContainer mainContainer2">
        <div class="content content2">
          <!-- 批量签署文件列表 -->
          <div class="batch-file-list">
            <div class="batch-list-title">合同列表</div>

            <div class="file-list-box">
              <div class="file-list">
                <div class="file-item">
                  <div class="file-name">
                    <el-checkbox
                      v-model="batchContactListChecked"
                      @change="onBatchContactListChecked"
                      size="medium"
                    ></el-checkbox>
                    <div class="file-name-text">所有合同</div>
                  </div>
                  <div class="file-number">
                    总共{{
                      batchContactList.length +
                      batchContactListNotModule.length
                    }}份
                  </div>
                </div>
                <div class="file-item flie-item-indent">
                  <div class="file-name">
                    <el-checkbox
                      v-model="batchContactListChecked"
                      @change="onBatchContactListChecked"
                      size="medium"
                    ></el-checkbox>
                    <div class="file-name-text">预制签章位置</div>
                  </div>
                  <div class="file-number">
                    总共{{ batchContactList.length }}份
                  </div>
                </div>
                <div
                  class="file-item flie-item-indent2"
                  v-for="item in batchContactList"
                  :key="item.id"
                  :class="{
                    'file-item-active': item.id === batchContactInfo.id,
                  }"
                >
                  <div class="file-name">
                    <el-checkbox
                      v-model="item.checked"
                      size="medium"
                      @change="batchContactListCheckedInspect"
                    ></el-checkbox>
                    <div
                      class="file-name-text"
                      @click="selectBatchContact(item)"
                    >
                      {{ item.name }}
                    </div>
                    <div class="add-tag" v-if="item.isSign">已加签</div>
                  </div>
                </div>
                <div
                  class="file-item flie-item-indent"
                  style="margin-top: 30px"
                >
                  <div class="file-name">
                    <el-checkbox disabled size="medium"></el-checkbox>
                    <div class="file-name-text">未预制位置</div>
                  </div>
                  <div class="file-number">
                    总共{{ batchContactListNotModule.length }}份
                  </div>
                </div>
                <div
                  class="file-item flie-item-indent2"
                  v-for="item in batchContactListNotModule"
                  :key="item.id"
                  :class="{
                    'file-item-active': item.id === batchContactInfo.id,
                  }"
                >
                  <div class="file-name">
                    <el-checkbox
                      v-model="item.checked"
                      disabled
                      size="medium"
                    ></el-checkbox>
                    <div
                      class="file-name-text"
                      @click="selectBatchContact(item)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 线上签署 -->
          <div v-if="!offlineSign" class="left left2 fl">
            <!-- <div class="tabSign">
              <span
                class="handwritings fl ft16 cursorPointer"
                :style="{ color: isHandwriting ? ' #E88078' : '#646464' }"
                @click="handelHandwriting(true)"
              >
                我的签章
                <i class="underLine" v-show="isHandwriting"></i>
              </span>
              <span
                class="handwritings fr ft16 cursorPointer"
                :style="{ color: !isHandwriting ? ' #E88078' : '#646464' }"
                @click="handelHandwriting(false)"
              >
                授权签章
                <i class="underLine" v-show="!isHandwriting"></i>
              </span>
            </div> -->
            <div class="seal-title">
              <div class="seal-title-text">印章</div>
              <div class="seal-title-number">
                共
                <span v-show="isHandwriting">{{ sealList.length }}</span>
                <span v-show="!isHandwriting">{{ sealAuthList.length }}</span>
                条
              </div>
            </div>
            <div class="seal-intro">
              公证文书已经预设了签名位置，选择签名并点击使用后，将自动定位
            </div>
            <div
              class="handwritingCon handwritingCon2"
              v-show="isHandwriting"
              id="mySealBox"
            >
              <div
                class="sign fl"
                v-for="(item, index) in sealList"
                :key="index"
              >
                <img
                  class="nor"
                  :src="item.fullFilePath"
                  alt
                  srcset
                  :data-sealid="item.id"
                  :data-imgsrc="item.fullFilePath"
                  @mousedown="mousedownQR($event)"
                  @mouseup="mouseupQR($event, '1')"
                />
                <!-- @dragstart="imageDrage($event)" -->
                <div
                  class="sign-button"
                  @click="handDrageSign(item, false, true)"
                >
                  {{ item.isUsed ? "已使用" : "使用" }}
                </div>
              </div>
              <!-- <div class="sign fl addSign cursorPointer" @click="handlerWrite">
                <img
                  class="nor"
                  src="../../../../../assets/images/sign/handwritten_icon_nor.png"
                  alt
                  srcset
                />
                <img
                  class="hov"
                  @mousedown="mousedownQR($event, 2)"
                  @mouseup="mouseupQR($event, '1')"
                  src="../../../../../assets/images/sign/handwritten_icon_hov_pre.png"
                  alt
                  srcset
                />
              </div> -->
            </div>
            <div
              class="handwritingCon handwritingCon2"
              v-show="!isHandwriting"
              id="agentSealBox"
              v-if="sealAuthList.length"
            >
              <div
                class="sign fl"
                v-for="(item, index) in sealAuthList"
                :key="index"
              >
                <img
                  class="nor"
                  :src="item.fullFilePath"
                  alt
                  srcset
                  :data-sealid="item.id"
                  :data-imgsrc="item.fullFilePath"
                  @mousedown="mousedownQR($event)"
                  @mouseup="mouseupQR($event, '1')"
                  @dragstart="imageDrage($event)"
                />
              </div>
            </div>
            <div
              class="handwritingCon handwritingCon2 noSeal"
              v-show="!isHandwriting"
              id="agentSealBox"
              v-if="!sealAuthList.length"
            >
              <img
                class="data-pic"
                src="../../../../../assets/images/H5/zwqz_icon.png"
                alt
              />
              <br />暂无授权签章
            </div>
          </div>
          <!-- 线下签署 -->
          <div v-else class="left fl">
            <OfflineSignStep
              :contractDetail="contractDetail"
              :fileArray="fileArray"
              @resetFileArray="resetFileArray"
            />
          </div>
          <div class="right right2 fl">
            <div class="tabContainerSignC">
              <div class="moreSign" v-if="showMoreBtn">
                <div class="selectMore">查看更多</div>
                <div class="allSignContainer">
                  <ul class="allSign">
                    <li
                      class="allSignItem ellipsis"
                      v-for="(item, index) in fileArray"
                      :key="index"
                      @click="changeShowTab(item)"
                    >
                      {{ item.fileName }}
                    </li>
                  </ul>
                </div>
              </div>

              <el-tabs
                v-model="activeName"
                type="card"
                @tab-click="activeChange"
              >
                <el-tab-pane
                  v-for="(item, index) in fileArray"
                  :key="index"
                  :label="item.filePathName || item.fileName"
                  :name="item.id"
                  :url="item.filePath"
                  :item="item"
                >
                  <!-- <div class="page">
                    <div
                      data-v-014c3cef
                      class="pagingSeal-btn pagingSeal-show"
                      v-show="signTypeSingle && !offlineSign"
                      @click="showQifeng"
                    >
                      骑缝签章
                    </div>
                    <div
                      data-v-014c3cef
                      class="pagingSeal-btn pagingSeal-show"
                      v-show="!signTypeSingle"
                      @click="showSingleSign"
                    >
                      普通签章
                    </div>
                    <span class="cursorPointer up" @click="toTop(item.id)">
                      <img
                        class="nor"
                        src="../../../../../assets/images/sign/up_icon_nor.png"
                        alt
                        srcset
                      />
                      <img
                        class="hov"
                        src="../../../../../assets/images/sign/up_icon_hov_pre.png"
                        alt
                        srcset
                      />
                    </span>
                    <span class="cursorPointer up" @click="toBottom(item.id)">
                      <img
                        class="nor"
                        src="../../../../../assets/images/sign/down_icon_nor.png"
                        alt
                        srcset
                      />
                      <img
                        class="hov"
                        src="../../../../../assets/images/sign/down_icon_hov_pre.png"
                        alt
                        srcset
                      />
                    </span>
                  </div> -->
                  <div class="page-handle">
                    <div class="handle-box" @click="toTop(item.id)">
                      <div class="handle-label">前往顶部</div>
                      <div class="handle-view up-handle">
                        <i class="el-icon-arrow-up"></i>
                      </div>
                    </div>
                    <div
                      v-if="batchContactInfo.currUserSealParam"
                      class="handle-box"
                      @click="scrolleToSealPositionHandler"
                    >
                      <div class="handle-label handle-label-red">
                        前往签章位置
                      </div>
                      <div class="handle-view right-handle">
                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                    <div class="handle-box" @click="toBottom(item.id)">
                      <div class="handle-label">前往底部</div>
                      <div class="handle-view down-handle">
                        <i class="el-icon-arrow-down"></i>
                      </div>
                    </div>
                  </div>
                  <div :id="item.id" class="pdfCon"></div>
                </el-tab-pane>
              </el-tabs>

              <!-- 前往底部 -->
            </div>
          </div>
        </div>
      </div>

      <!-- <Dialog
          :visible="partWithoutSign"
          :dialogTitle="'温馨提示'"
          :width="'400px'"
          @closeDialog="closePartWithoutSign"
        >
          <div class="signDialog" slot="dialog">
            <div class="authDscp">
              <p>您有 {{count}}份合同上未签署，是否确认完成签署？</p>,
            </div>
            <div class="authHandlerBox">
              <div class="button cursorPointer" @click="closePartWithoutSign(false)">取消</div>
              <div class="button buttonActive cursorPointer" @click="signConfirm">确定</div>
            </div>
          </div>
        </Dialog> -->
      <Dialog
        :visible="qfSealDialogVisible"
        :width="'500px'"
        v-on:closeDialog="qfSealDialogVisible = false"
      >
        <div slot="dialog" class="newDialog">
          <p class="scanning ft16">您还没有加盖骑缝章</p>
          <p class="effective ft14">请确认是否继续提交签署？</p>
          <div class="footer">
            <el-button type="danger" @click="qfSealDialogVisible = false"
              >去加盖</el-button
            >
            <el-button @click="confirm = true">继续提交</el-button>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="dialogVisible"
        :dialogTitle="'手写签章'"
        v-on:closeDialog="closeDialog"
        :width="'500px'"
      >
        <div slot="dialog" class="handwritingModal">
          <p class="scanning ft16">请打开手机上的扫一扫功能，扫描以下二维码</p>
          <p class="effective ft14">-二维码5分钟内有效-</p>
          <vue-qr
            id="canvas"
            :logoSrc="imageUrl"
            :text="codeValue"
            :size="200"
          ></vue-qr>
          <p class="warning ft12">
            <i>提醒：</i
            >通过扫描二维码功能签署的签名，即表示我同意将该签名作为我的正式签名用于我（或我的代理）的各种文档处理用途，包括具有法律约束力的合约，与用笔在纸上签名具有相同效力。
          </p>
        </div>
      </Dialog>
      <Dialog
        :visible="signing"
        :dialogTitle="'安全验证'"
        v-on:closeDialog="closePassword"
        :width="'500px'"
      >
        <div slot="dialog" class="signing">
          <div class="dialog_header" v-show="codeStatus != 0">
            <template v-if="isUpdate">
              <p
                v-for="item in daglogHeader"
                :key="item.type"
                @click="changeTitle(item.type)"
                :class="[signtype == item.type ? 'active' : '']"
              >
                <span>{{ item.name }}</span>
              </p>
            </template>
            <template v-if="!isUpdate">
              <p
                v-for="item in daglogHeader"
                :key="item.type"
                @click="changeTitle(item.type)"
                style="width: 100%"
                v-show="signtype == item.type"
                :class="[signtype == item.type ? 'active' : 'no-active']"
              >
                <span>{{ item.name }}</span>
              </p>
            </template>
          </div>
          <div v-if="signtype == 1">
            <div class="password ft12">
              <el-form
                :model="signForm"
                :rules="signFormRule"
                ref="signForm"
                label-width="0px"
                size="mini"
                @submit.native.prevent
              >
                <el-form-item
                  label="签约密码："
                  label-width="95px"
                  prop="password"
                  class="password"
                >
                  <el-input
                    class="input"
                    type="password"
                    v-model="signForm.password"
                    placeholder="请输入内容"
                  ></el-input>
                  <span class="forget" @click="handelForgetPassword()"
                    >忘记密码</span
                  >
                </el-form-item>
              </el-form>
            </div>
            <div class="cancel">
              <el-button plain class="can" @click="closePassword(false)"
                >取消</el-button
              >
              <el-button
                type="danger"
                :disabled="isSubmitIng"
                class="sure"
                @click="signRep(signInfo)"
                >确定</el-button
              >
            </div>
          </div>
          <div class="rlsb" v-if="signtype == 0">
            <p class="rlsb_title">
              <span></span>&nbsp;二维码5分钟内有效&nbsp;<span></span>
            </p>
            <div class="erweima" v-show="codeStatus != 0 && !error_num">
              <vue-qr id="canvass" :text="erweimaUrl" :size="200"></vue-qr>
            </div>
            <div
              class="erweima_errro"
              v-show="error_erweima && codeStatus != 0"
            >
              <p class="error_title">二维码失效</p>
              <span class="update_erweima" @click="updateEr">点击刷新</span>
            </div>
            <div
              class="erweima_errro"
              style="width: 270px; margin-left: -135px"
              v-show="error_num"
            >
              <p class="error_title">{{ text }}</p>
            </div>
            <div
              class="erweima_success"
              style="top: 25px"
              v-show="(status == 1 || status == 2) && codeStatus != 0"
            >
              <img
                src="../../../../../assets/images/userHome/wxsmcg_icon.png"
              />
              <p class="success_title" style="margin-top: 0px">扫描成功</p>
              <p class="success_desc">请在手机端刷脸认证</p>
              <span class="success_update_erweima" @click="updateEr"
                >点击刷新</span
              >
            </div>
            <div class="erweima_success" v-show="codeStatus == 0">
              <img
                src="../../../../../assets/images/userHome/wxsmcg_iconS.png"
              />
              <p class="success_title">已完成人脸验证</p>
            </div>
            <p
              class="rlsb_desc"
              :style="{ 'margin-top': codeStatus == 0 ? '180px' : '20px' }"
            >
              请使用微信或其他软件扫描二维码，并依照提示完成人脸识别认证
            </p>
            <button
              class="success_face"
              type="button"
              v-show="status == 1 || status == 2"
              @click="getFaceResult"
            >
              已完成人脸验证
            </button>
            <!-- <button class="error_face" type="button">未完成人脸验证</button> -->
          </div>
        </div>
      </Dialog>
      <reject-sign
        v-if="rejectShow"
        @closeDialog="rejectShow = false"
        :taskId="rejectTaskId"
        @findPaw="findPawHandler"
        @restDetail="goDetail"
      ></reject-sign>
      <tip-to-set-sign-pwd></tip-to-set-sign-pwd>
      <findpaw
        v-if="forgetPassword"
        @closeDialog="forgetPassword = false"
      ></findpaw>
      <!-- 人脸识别失败 -->
      <!-- 人脸识别失败 -->
      <div class="masks" v-if="codeStatus == -1 && openTest">
        <p>
          {{ text }}
        </p>
      </div>
    </div>
    <div style="height: 1px"></div>

    <div class="footer">
      <el-button type="danger" plain class="btn submitBtn" @click="onClearSign"
        >清除加签</el-button
      >
      <el-button
        type="danger"
        plain
        class="btn submitBtn"
        @click="onBatchSignSubmit"
        >批量签署</el-button
      >
      <!-- <el-button type="danger" plain class="ret" @click="goBack"
        >返回</el-button
      > -->
      <!-- <el-button @click="handelConfirm()" type="danger" plain class="btn submitBtn"
        >提交</el-button
      > -->
      <!-- <el-button
        type="danger"
        plain
        class="btn submitBtn"
        @click="rejectSign"
        v-if="$route.query.isCanReject == 1"
        >拒签</el-button
      > -->
    </div>
  </div>
</template>
  <script>
import Dialog from "../../../../common/Dialog.vue";
import VueQr from "vue-qr";
import troVue from "../../../../tro.vue";
import DargApi from "@lib/dragApi.js";
import browser from "@lib/getBrowser.js";
import BaseApi from "@lib/baseApi.js";
import Util from "@lib/util.js";
import findpaw from "./findPaw.vue";
import tipToSetSignPwd from "./tipToSetSignPwd.vue";
import WebSockt from "@lib/webSocket.js";
import RejectSign from "./RejectSign.vue";
import { mapState, mapGetters } from "vuex";
import Reg from "@lib/reg.js";
import config from "@lib/config.js";
import Breadcrumb from "../../../../../components/common/Breadcrumb.vue";
import md5Util from "@lib/encryption.js";
import faceError from "@common/faceError.vue"; //实名认证失败
import OfflineSignStep from "./offlineSignStep.vue";
import PersonalHead from "../../../../common/PersonalHead.vue";
// Util.getLocationByIp();
let getMouseXY = function (e) {
  var x = 0,
    y = 0;
  e = e || window.event;
  if (e.pageX) {
    x = e.pageX;
    y = e.pageY;
  } else {
    x = e.clientX + document.body.scrollLeft - document.body.clientLeft;
    y = e.clientY + document.body.scrollTop - document.body.clientTop;
  }
  return {
    x: x,
    y: y,
  };
};
let dragStart = function (event, element, scrollTop = 0) {
  // console.log(event,element,scrollTop)
  event.stopPropagation();
  let boxX = element.offsetLeft;
  let boxY = element.offsetTop;
  // 获取鼠标所在的坐标 old
  // let mouseX =parseInt(getMouseXY(event).x);
  // let mouseY =parseInt(getMouseXY(event).y);
  //new
  let mouseX = event.layerX;
  let mouseY = event.layerY;
  // console.log(mouseX,mouseY,boxX,boxY)
  // console.log(mouseY - boxY - scrollTop);
  return {
    x: mouseX - boxX,
    y: mouseY - boxY + scrollTop,
  };
};
export default {
  components: {
    Dialog: Dialog,
    VueQr,
    findpaw,
    Breadcrumb,
    RejectSign,
    tipToSetSignPwd,
    faceError,
    OfflineSignStep,
    PersonalHead,
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    ...mapState(["currentInfo", "curState"]),
  },
  data() {
    return {
      isUpdate: true,
      erweimaUrl: "",
      //二维码扫描成功
      success_erweima: false,
      //二维码失效
      error_erweima: false,
      //二维码弹框
      signing: false,
      orderNo: "", //订单号
      status: 0, //二维码状态
      codeStatus: null, //认证状态
      openTest: false,
      haveQfSealList: [], //骑缝签章列表
      signForm: {
        password: "",
      },
      signFormRule: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: Reg.PWD,
            message: "密码为6-18位数字或者字母",
            trigger: "blur",
          },
        ],
      },
      //认证头部
      daglogHeader: [
        {
          id: "1",
          name: "签约密码",
          type: 1,
        },
        {
          id: "0",
          name: "人脸识别",
          type: 0,
        },
      ],
      // newDaglogHeader:[],
      signtype: 1, //选择哪种认证方式
      rejectShow: false,
      rejectTaskId: "",
      isHandwriting: true, //手写签章
      dialogVisible: false,
      codeValue: "http://192.168.1.121:4200/canvasSign/sign.html",
      imageUrl: require("@image/sign/qrcode.png"),
      password: "",
      forgetPassword: false,
      signTypeSingle: true,
      activeName: "128845d5cc8e4fe89d65d15624154987",
      currentItem: null,
      // 当前要移动的盒子鼠标的位置
      currentMousePosition: null,
      showMoreBtn: false,
      fileArray: [],
      sealList: [],
      sealAuthList: [],
      partWithoutSign: false,
      count: 0,
      signInfo: {},
      isSubmitIng: false,
      userID: "",
      error_num: false,
      text: "",
      newCurInfo: {},
      result: {},
      curSealist: [], //接口获取的当前合同坐标
      writeCur: {}, //当前手写签名
      isShowDrag: true,
      isShowQFDrag: true, //是否有骑缝张拖拽
      userPersonInfo: {}, //个人实名信息
      isHaveCreate: false,
      isAutoSing: false, //是否来自手写签章
      curUserIdEnterprise: [],
      prevSign: null, // 旧的签章，避免多次签章覆盖
      prevSignElement: null,
      alertVisible: true, // alert 显隐
      qfSealDialogVisible: false,
      confirm: false,

      contractDetail: {}, // 合同详情 contractDetail->info->offlineSign
      offlineSign: false, // 当前用户是否为线下签署

      // 批量签署部分
      batchContactList: [], // 批量合同列表 预制
      batchContactListNotModule: [], // 批量合同列表 非模板合同
      batchContactInfo: {}, // 当前预览合同信息
      batchContactListChecked: false, // 预制签章是否全选
    };
  },
  created() {},
  mounted() {
    this.isHandwriting = this.$route.query.isHandwriting;
    console.log(this.isHandwriting, "isHandwriting");
    // this.getPdfToImage();
    $(window).resize(() =>
      // 绑定到窗口的这个事件中
      {
        this.judgeMoreShow();
      }
    );
    this.getBatchContactList();
    this.getuserId();
  },
  methods: {
    // 获取批量文件列表
    getBatchContactList() {
      let SignMediateBatch = sessionStorage.getItem("SignMediateBatch");
      if (SignMediateBatch) {
        let batchContactListNotModule = [];
        let batchContactList = [];
        SignMediateBatch = JSON.parse(SignMediateBatch);
        SignMediateBatch.forEach((item) => {
          item.checked = false;
          item.isSign = false; // 是否已印章
          item.isSignInfo = null; // 有过已有印章，印章数据填入
          item.isSignPosition = null; // 印章坐标
          if (item.currUserSealParam) {
            batchContactList.push(item);
          } else {
            batchContactListNotModule.push(item);
          }
        });
        this.batchContactList = batchContactList;
        this.batchContactListNotModule = batchContactListNotModule;
        this.selectBatchContact(SignMediateBatch[0]);
      }
    },
    async selectBatchContact(item) {
      this.batchContactInfo = item;
      this.fileArray = [];
      this.getFiled(item);
      this.getauthSeaList(item);
      this.getContractDetail();
    },
    // 预制签章全选
    onBatchContactListChecked(val) {
      if (val) {
        // 全选
        this.batchContactList.forEach((item) => {
          item.checked = true;
        });
      } else {
        this.batchContactList.forEach((item) => {
          item.checked = false;
        });
      }
    },
    // 检查预制签章检查情况
    batchContactListCheckedInspect() {
      let isAll = true;
      this.batchContactList.forEach((item) => {
        if (!item.checked) {
          isAll = false;
        }
      });
      this.batchContactListChecked = isAll;
    },

    //获取合同坐标
    getFilePoistion() {
      if (this.batchContactInfo.currUserSealParam) {
        // 设置签章坐标
        this.batchContactInfo.isSignPosition =
          this.batchContactInfo.currUserSealParam[0];
        this.curSealist = this.batchContactInfo.currUserSealParam;
        setTimeout(() => {
          if (
            this.batchContactInfo.isSign &&
            this.batchContactInfo.isSignInfo
          ) {
            this.handDrageSign(this.batchContactInfo.isSignInfo, true);
          } else {
            // 增加印章位置提示
            this.sealPositionTipHand();
          }
        }, 1000);
        this.isShowDrag = false;
      } else {
        this.isShowDrag = true;
        // this.$message.error("未获取到签章坐标");
      }

      // BaseApi.createRpcToken(
      //   "/contract/v2/getContractPosition",
      //   {
      //     contractId: this.batchContactInfo.id,
      //     keyword: "crd.sgn",
      //   },
      //   "GET"
      // )
      //   .then(
      //     (data) => {
      //       if (data.code == 200) {
      //         if (data.datas && data.datas.position.length) {

      //         } else {
      //           this.isShowDrag = true;
      //           this.$message.error("未获取到签章坐标");
      //         }
      //         // console.log(this.curSealist)
      //       }
      //     },
      //     (data) => {}
      //   )
      //   .catch(function (e) {
      //     errorLog(e);
      //   });
    },
    //获取userId
    getuserId() {
      BaseApi.createRpcToken("/user/v2/getUserInfo", "GET")
        .then(
          (data) => {
            if (data.code == 200) {
              if (data.datas.currentUserId == data.datas.person.userId) {
                this.newCurInfo = data.datas.person;
              } else {
                this.newCurInfo = data.datas.enterpriseList[0];
              }
              this.userPersonInfo = data.datas.person;
              this.userID = data.datas.currentUserId;
              this.getSealList();
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //获取人脸识别二维码
    getFaceAuthOrderNo() {
      var timer = null;
      let _this = this;

      let list = [];
      this.batchContactList.forEach((item) => {
        if (item.isSign && item.checked && item.isSignInfo) {
          list.push(item);
        }
      });
      if (!list && !list.length) {
        this.$message.info("请选择已印章的合同");
        return;
      }
      console.log(list, "list");
      // 取批量 的第一个合同id
      let htid = list[0].id;

      //第三步进行人脸识别验证

      let queryStrUrl = {
        liveType: 2,
        contractId: htid,
        userId: _this.userPersonInfo.userId,
      };
      //获取二维码地址
      clearInterval(timer);
      BaseApi.createRpcToken("/user/getFaceAuthOrderNo", queryStrUrl, "GET")
        .then(
          (data) => {
            if (data.code == 200) {
              var endTime = new Date().getTime() + 5 * 60 * 1000;
              this.orderNo = data.datas.orderNo; //data.datas.url
              if (data.datas.orderNo != -1) {
                this.setTimerEr();
                let userIDd = localStorage.getItem("userId")
                  ? localStorage.getItem("userId")
                  : this.userID;
                this.erweimaUrl =
                  data.datas.url +
                  "?orderNo=" +
                  data.datas.orderNo +
                  "&userId=" +
                  userIDd;
                timer = setInterval(() => {
                  var start = new Date().getTime();
                  if (start > endTime) {
                    this.error_erweima = true;
                    this.status = 0;
                    clearInterval(timer);
                  } else {
                    if (this.status == 1 || this.status == 2) {
                      clearInterval(timer);
                      this.error_erweima = false;
                    } else {
                      this.error_erweima = false;
                    }
                  }
                }, 1000);
                if (this.status == 1 || this.status == 2) {
                  clearInterval(timer);
                  this.error_erweima = false;
                }
              } else {
                this.text = " 人脸识别服务异常，请联系管理员！";
                this.error_num = true;
                this.status = 0;
                this.error_erweima = false;
              }
            } else {
              // console.log('erweimadizhi error',data)
              this.error_erweima = true;
              this.status = 0;
            }
          },
          (data) => {
            if (data.code == 107) {
              this.error_erweima = true;
            }
          }
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //实时获取二维码状态
    setTimerEr() {
      var timer = null;
      let orderNos = this.orderNo;
      var obj = { orderNo: orderNos };
      BaseApi.createRpcToken(
        "/user/getFaceAuthStatus",
        { orderNo: orderNos },
        "GET"
      )
        .then(
          (data) => {
            if (data.code == 200) {
              clearTimeout(timer);
              this.status = data.datas.status;
              this.codeStatus = data.datas.authStauts;
              let self = this;
              if (self && !self._isDestroyed) {
                timer = setTimeout(() => {
                  this.setTimerEr();
                }, 1000);
              }
              if (obj.orderNo != this.orderNo) {
                clearTimeout(timer);
              }
              //二维码失效
              else if (this.error_erweima) {
                clearTimeout(timer);
              }
              //成功
              else if (data.datas.authStauts == 0) {
                clearTimeout(timer);
              }
              //失败0-成功，-1未完成，其余都是失败。
              else if (
                data.datas.authStauts != 0 &&
                data.datas.authStauts != -1
              ) {
                clearTimeout(timer);
              }
            } else {
              clearTimeout(timer); //清理定时任务
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //刷新二维码
    updateEr() {
      if (this.codeStatus == 0) {
        return;
      } else {
        this.error_erweima = false;
        this.getFaceAuthOrderNo();
      }
    },
    //获取实名认证结果
    getFaceResult() {
      var timer = null;
      let orderNos = this.orderNo;
      clearTimeout(timer);
      if (this.codeStatus == 0) {
        BaseApi.createRpcToken(
          "/user/getFaceAuthStatus",
          { orderNo: orderNos },
          "get"
        )
          .then(
            (data) => {
              if (data.datas.authStauts == 0) {
                this.codeStatus = data.datas.authStauts;
                this.signByFaceAuth(orderNos);
              } else {
                this.codeStatus = data.datas.authStauts;
              }
            },
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      } else {
        this.codeStatus = -1;
        this.openTest = true;
        this.text = "人脸识别认证失败，请重试";
        timer = setTimeout(() => {
          this.codeStatus = -2;
          this.openTest = false;
        }, 5000);
      }
    },
    //人脸识别签署
    signByFaceAuth(orderNos) {
      let list = [];
      this.batchContactList.forEach((item) => {
        if (item.isSign && item.checked && item.isSignInfo) {
          list.push({
            contractId: item.id,
            sealId: item.isSignInfo.id,
          });
        }
      });
      if (!list || !list.length) {
        this.$message.info("请选择已加签的合同");
        return;
      }

      // 使用第一个
      this.signInfo.data.orderNo = orderNos;
      // console.log(this.signInfo.data,"签署",orderNos,"订单号",this.signInfo.data.orderNo)
      // 批量签署
      BaseApi.createRpcToken(
        "/contract/batchSign",
        {
          orderNo: orderNos,
          sealParams: JSON.stringify(list),
        },
        "post"
      )
        .then(
          (data) => {
            if (data.code === 200) {
              this.$message.success("正在签署" + list.length + "份协议");
              this.$router.back();
            }
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //改变认证头部
    changeTitle(type) {
      if (this.isUpdate) {
        this.signtype = type;
      } else {
        $(".dialog_header p.no-active").css("cursor", "not-allowed");
      }
    },
    findPawHandler() {
      this.rejectShow = false;
      this.forgetPassword = true;
    },
    signConfirm() {
      let orderNos = this.orderNo;
      if (this.codeStatus == 0) {
        this.signing = true;
      } else {
        this.signing = true;
        //获取二维码
        this.getFaceAuthOrderNo();
      }
    },
    goBack() {
      history.go(-1);
    },

    goDetail() {
      this.$router.push(`/personal/sign/detail?id=${this.batchContactInfo.id}`);
    },
    changeShowTab(item) {
      this.activeName = item.id;
      this.activeChange("", item);
    },
    mousedownQR(e) {
      let scorllTop = 0;
      if (this.isHandwriting) {
        scorllTop = $("#mySealBox").scrollTop();
      } else {
        scorllTop = $("#agentSealBox").scrollTop();
      }
      this.currentMousePosition = dragStart(
        e,
        $(e.srcElement || e.target).parent()[0],
        scorllTop
      );
      console.log(this.currentMousePosition, "鼠标的位置");
    },
    toUploadSeal() {
      this.$router.push("/personal/users/signature");
    },
    mouseupQR(e, flag) {},
    judgeMoreShow() {
      let interValFlag = setInterval(() => {
        if ($(".el-tabs__nav-wrap").width()) {
          clearInterval(interValFlag);
          if ($(".el-tabs__nav-next")[0]) {
            this.showMoreBtn = true;
          } else {
            this.showMoreBtn = false;
          }
        }
      }, 10);
    },
    toTop(id) {
      $(`#${id}`).scrollTop(0);
    },
    toBottom(id) {
      $(`#${id}`).scrollTop($(`#${id}`)[0].scrollHeight);
    },
    imageDrage(e) {
      e.dataTransfer.setData(
        "sealid",
        (e.srcElement || e.target).dataset.sealid
      );
      e.dataTransfer.setData(
        "imgsrc",
        (e.srcElement || e.target).dataset.imgsrc
      );
    },
    // 点击使用后，自动签署至pdf
    handDrageSign(item, isSelectSign, isScrollToSeal) {
      // isSelectSign 是否需要直接加签 该判断主要是切换合同时使用
      console.log(item);
      console.log(this.batchContactInfo);
      if (!isSelectSign) {
        this.handDrageSignSelected(item);
      }
      if (!this.batchContactInfo.isSignPosition) {
        return;
      }
      if (!isSelectSign && !this.batchContactInfo.checked) {
        // 未选中当前的合同，则无需进行加签操作
        return;
      }
      if (!isSelectSign && this.batchContactInfo.isSign) {
        // this.$message.info("该协议已加签");
        return;
      }
      this.batchContactInfo.isSignInfo = item;
      let s_id = this.fileArray[0].id;
      let el = $(".canvasBoxFlag");
      if (this.signTypeSingle) {
        let sealid = item.id;
        let imgsrc = item.fullFilePath;
        let parentMent = el;
        // 生成得到页面上的章唯一id
        let uid = Util.getUID();
        if (!this.batchContactInfo.isSignPosition) {
          this.$message.error("仅支持有预制签章位置的合同");
          return;
        }
        let sealPos = this.batchContactInfo.isSignPosition.sealPos[0];
        if (!sealPos) {
          this.$message.error("仅支持有预制签章位置的合同");
          return;
        }

        let x = sealPos.llx;
        let y = sealPos.ruy;

        let canvasheight = $(parentMent[sealPos.pageNo - 1]).height();
        console.log($(parentMent));
        // console.log(canvasheight,'canvasheight')
        y = canvasheight - sealPos.ruy;

        let isparent = true;
        this.currentMousePosition = {
          x: 0,
          y: 0,
        };

        if (sealid && imgsrc) {
          // 清除加签位置提示块
          let sealTipElement = $(".seal-tip-normal")[0];
          if (sealTipElement) {
            sealTipElement.remove();
          }

          let element = $(
            `<div ><div class='deleteSeal' data-uid="${uid}" data-sealid ="${sealid}"> 删除</div></div>`
          );
          element.addClass("sealNormal");
          let heights =
            document.getElementsByClassName("canvasContent")[0].height;
          let widths =
            document.getElementsByClassName("canvasContent")[0].width;
          element.css({
            top:
              y < this.currentMousePosition.y
                ? 0
                : heights - y < 50
                ? heights - 119
                : isparent
                ? y - this.currentMousePosition.y
                : y + this.currentMousePosition.y - 59.5,
            left:
              x < this.currentMousePosition.x
                ? 0
                : widths - x < 50
                ? widths - 119
                : isparent
                ? x - this.currentMousePosition.x
                : x + this.currentMousePosition.x - 59.5,
          });
          this.currentItem.sealPos = this.currentItem.sealPos || {};
          this.addSeal(
            element,
            $(parentMent[sealPos.pageNo - 1]),
            imgsrc,
            sealid,
            uid,
            x < this.currentMousePosition.x
              ? 0
              : widths - x < 50
              ? widths - 119
              : isparent
              ? x - this.currentMousePosition.x
              : x + this.currentMousePosition.x - 59.5,
            y < this.currentMousePosition.y
              ? 0
              : heights - y < 50
              ? heights - 119
              : isparent
              ? y - this.currentMousePosition.y
              : y + this.currentMousePosition.y - 59.5
          );

          // 滚动到签章的位置
          if (isScrollToSeal) {
            setTimeout(() => {
              this.scrolleToSealPosition(parentMent, sealPos, y);
            }, 100);
          }
        } else {
          this.handlerWrite(true, uid, x, y, $(parentMent[sealPos.pageNo - 1]));
        }
      }
    },
    // 给已选择的合同加上 已加签
    handDrageSignSelected(info) {
      this.batchContactList.forEach((item) => {
        // 当前的无需在这里进行加签操作
        if (item.checked && item.id !== this.batchContactInfo.id) {
          item.isSignInfo = info;
          item.isSign = true;
        }
      });
      this.sealListInitUsed();
    },

    // 印章位置提示
    sealPositionTipHand() {
      let el = $(".canvasBoxFlag");
      if (this.signTypeSingle) {
        let parentMent = el;
        // 生成得到页面上的章唯一id
        let uid = Util.getUID();
        if (!this.batchContactInfo.isSignPosition) {
          return;
        }
        let sealPos = this.batchContactInfo.isSignPosition.sealPos[0];
        if (!sealPos) {
          return;
        }

        let x = sealPos.llx;
        let y = sealPos.ruy;

        let canvasheight = $(parentMent[sealPos.pageNo - 1]).height();
        // console.log(canvasheight,'canvasheight')
        y = canvasheight - sealPos.ruy;

        let isparent = true;
        this.currentMousePosition = {
          x: 0,
          y: 0,
        };

        let element = $(`<div class="seal-tip-normal">您的加签位置</div>`);
        let heights =
          document.getElementsByClassName("canvasContent")[0].height;
        let widths = document.getElementsByClassName("canvasContent")[0].width;
        element.css({
          top:
            y < this.currentMousePosition.y
              ? 0
              : heights - y < 50
              ? heights - 119
              : isparent
              ? y - this.currentMousePosition.y
              : y + this.currentMousePosition.y - 59.5,
          left:
            x < this.currentMousePosition.x
              ? 0
              : widths - x < 50
              ? widths - 119
              : isparent
              ? x - this.currentMousePosition.x
              : x + this.currentMousePosition.x - 59.5,
        });
        this.currentItem.sealPos = this.currentItem.sealPos || {};
        // this.addSeal(
        //   element,
        //   $(parentMent[sealPos.pageNo - 1]),
        //   imgsrc,
        //   sealid,
        //   uid,
        //   x < this.currentMousePosition.x
        //     ? 0
        //     : widths - x < 50
        //     ? widths - 119
        //     : isparent
        //     ? x - this.currentMousePosition.x
        //     : x + this.currentMousePosition.x - 59.5,
        //   y < this.currentMousePosition.y
        //     ? 0
        //     : heights - y < 50
        //     ? heights - 119
        //     : isparent
        //     ? y - this.currentMousePosition.y
        //     : y + this.currentMousePosition.y - 59.5
        // );
        $(parentMent[sealPos.pageNo - 1]).append(element);
      }
    },
    // 滚动到签章的位置
    scrolleToSealPosition(parentMent, isSignPosition, y) {
      //滚动到签章的位置
      $(parentMent)
        .parent()
        .animate(
          {
            scrollTop: 841 * parseInt(isSignPosition.pageNo) - (y + 119),
          },
          200
        );
    },
    scrolleToSealPositionHandler() {
      let parentMent = $(".canvasBoxFlag");
      let sealPos = this.batchContactInfo.isSignPosition.sealPos[0];
      if (!sealPos) {
        this.$message.error("未获取到坐标信息");
        return;
      }
      let x = sealPos.llx;
      let y = sealPos.ruy;
      let canvasheight = $(parentMent[sealPos.pageNo - 1]).height();
      y = canvasheight - sealPos.ruy;
      this.scrolleToSealPosition(parentMent, sealPos, y);
    },

    handelForgetPassword() {
      this.signing = false;
      this.forgetPassword = true;
    },
    closePassword(data) {
      this.signing = data;
    },
    closePartWithoutSign(data) {
      this.partWithoutSign = data;
    },
    getFiled() {
      let isReSign = this.$route.query.isReSign;
      if (isReSign) {
        // 重新签署
        BaseApi.createRpcToken("/file/listBeforeSign", {
          id: this.batchContactInfo.id || 1,
        }).then(
          (data) => {
            this.fileArray = data.datas.list;
            this.activeChange("", this.fileArray[0]);
            this.judgeMoreShow();

            this.getFilePoistion();
          },
          () => {}
        );
      } else {
        BaseApi.createRpcToken("/file/list", {
          id: this.batchContactInfo.id || 1,
        }).then(
          (data) => {
            this.fileArray = data.datas.list;
            this.activeChange("", this.fileArray[0]);
            this.judgeMoreShow();
          },
          () => {}
        );
      }
    },
    getSealList() {
      BaseApi.createRpcToken("/seal/v2/sealList", {
        checkStatus: 2,
      })
        .then(
          (data) => {
            if (data.datas && data.datas.resultList) {
              let list = [];
              list = data.datas.resultList.filter(
                (item) => item.sealType == this.newCurInfo.realNameType
              );
              list.forEach((item) => {
                item.isUsed = false;
              });
              this.sealList = list;
            } else {
              this.sealList = [];
            }
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    // 判断签名是否已经被使用
    sealListInitUsed() {
      this.sealList.forEach((item) => {
        item.isUsed = false;
        this.batchContactList.forEach((item2) => {
          if (
            item2.isSign &&
            item2.isSignInfo &&
            item2.isSignInfo.id === item.id
          ) {
            item.isUsed = true;
          }
        });
      });
    },
    rejectSign() {
      this.rejectTaskId = this.batchContactInfo.taskId;
      this.rejectShow = true;
    },
    getauthSeaList() {
      BaseApi.createRpcToken("/seal/authorizedSealList", {
        taskId: this.batchContactInfo.taskId,
        contractId: this.batchContactInfo.id,
      }).then(
        (data) => {
          this.sealAuthList = (data.datas && data.datas.resultList) || [];
        },
        () => {}
      );
    },
    activeChange(node, item) {
      this.currentItem = (node && node.$attrs.item) || item;
      this.activeName = this.currentItem.id;
      if (!this.currentItem.isAdd) {
        this.currentItem.isAdd = true;
        this.$nextTick(() => {
          this.getPdfToImage(this.currentItem.filePath, this.currentItem.id);
        });
      }
      let fileArrt = sessionStorage.getItem("curFIle")
        ? JSON.parse(sessionStorage.getItem("curFIle"))
        : this.haveQfSealList;
      setTimeout(() => {
        Array.prototype.forEach.call(
          $(`#${this.currentItem.id}`).children(".canvasBoxFlag"),
          (value) => {
            Array.prototype.forEach.call(
              $(value).children(".qifengSeal"),
              (childValue) => {
                if (this.currentItem.id == $(childValue).attr("id")) {
                  $(childValue).css({
                    display: "block",
                  });
                  $(childValue)
                    .siblings(".qifengSeal")
                    .css({ display: "none" });
                } else {
                  $(childValue).css({
                    display: "none",
                  });
                }
              }
            );
          }
        );
      });
    },
    getPage(page, index, id) {
      var scale = 1; //缩放倍数，1表示原始大小
      var viewport = page.getViewport(scale);
      var canvas = document.getElementById("canvas" + index + id);
      var canvasFather = canvas.parentNode;
      var context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      canvasFather.style.width = viewport.width + "px";
      canvasFather.style.height = viewport.height + "px";
      canvasFather.style.margin = "10px auto";
      var renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
      page.render(renderContext).promise.then(() => {
        this.loadedPageCount++;
      });
    },
    showQifeng() {
      $(`.qifenFlag`).addClass("qifenDong");
      $(`.qifenFlag`).addClass("pagingSeal-transition");
      $(".qifengPaddingFlag").removeClass("qifengPadding");
      $(".qifengSeal").removeClass("qifengSealMove");
      this.signTypeSingle = !this.signTypeSingle;
    },
    showSingleSign() {
      $(`.qifenFlag`).removeClass("qifenDong");
      $(`.qifenFlag`).removeClass("pagingSeal-transition");
      $(".qifengPaddingFlag").addClass("qifengPadding");
      $(".qifengSeal").addClass("qifengSealMove");
      this.signTypeSingle = !this.signTypeSingle;
      if (!document.querySelector(".qifengSeal")) {
        this.$message({
          message: "骑缝章没有加盖成功",
          type: "warning",
        });
      }
    },
    getPdfToImage(url, id) {
      let container = document.getElementById(id);
      container.style.display = "block";
      let _this = this;
      url = url;
      PDFJS.getDocument({ url: url }).then(function getPdfHelloWorld(pdf) {
        _this.totalPage = pdf.numPages;
        for (let i = 1; i <= _this.totalPage; i++) {
          $(container).append(
            `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas><p class="pdfPageFlag">${i}/${_this.totalPage}</p><div class="qifenFlag"></div></div>`
          );
          let obj = $("#canvasBoxFlag" + i + id)[0];
          obj.addEventListener("dragenter", _this.drag, false);
          obj.addEventListener("dragover", _this.drag, false);
          obj.addEventListener("dragleave", _this.drag, false);
          obj.addEventListener("drop", _this.drag, false);
        }
        $(".qifenFlag").on("dragenter", (ev) => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".qifenFlag").on("dragover", (ev) => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".qifenFlag").on("dragleave", (ev) => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".qifenFlag").on("drop", (ev) => {
          _this.dragQifen(ev.originalEvent);
        });
        $(".canvasBoxFlag").addClass("canvasBox");
        $(".pdfPageFlag").addClass("pdfPage");
        for (let i = 1; i <= _this.totalPage; i++) {
          pdf.getPage(i).then((page) => {
            _this.getPage(page, i, id);
          });
        }
        if (!_this.signTypeSingle) {
          _this.showQifeng();
          _this.signTypeSingle = false;
        }
      });
    },
    //普通签章坐标
    setPostion(x, y, sealid, uid, prentMent) {
      /**
       * 合同计算签章坐标点：   定位 top、left
          坐标: canvasheight = 841.9;页数的高度
          llx : left
          lly: canvasheight -  top - 119
          rux: left- 0 +119
          ruy:canvasHeight - top
       * */
      let canvasheight = prentMent.height();
      this.currentItem.sealPos[sealid][uid] = {
        pageNo: prentMent[0].dataset.pageindex,
        llx: x,
        lly: canvasheight - y - 119,
        rux: x - 0 + 119,
        ruy: canvasheight - y,
        type: 0,
      };
    },
    //骑缝签章坐标
    setQFPostion(y, sealid, uid, firstCanvasWheight) {
      this.currentItem.sealPos = this.currentItem.sealPos || {};
      this.currentItem.sealPos[sealid] = this.currentItem.sealPos[sealid] || {};
      this.currentItem.sealPos[sealid][uid] = {
        height: firstCanvasWheight - y - 110,
        type: 1,
      };
    },
    addSeal(element, parentMent, imgsrc, sealid, uid, x, y) {
      element.append(
        `<img src=${imgsrc} data-uid="${uid}" data-sealid =${sealid} draggable="false"/>`
      );
      this.currentItem.sealPos[sealid] = this.currentItem.sealPos[sealid] || {};
      this.setPostion(x, y, sealid, uid, parentMent);
      // let dragElement = new DargApi(
      //   element[0],
      //   parentMent[0],
      //   false,
      //   false,
      //   (x, y, e) => {
      //     let element = e.target || e.srcElement;
      //     let sealid = element.dataset.sealid;
      //     let uid = element.dataset.uid;
      //     this.setPostion(x, y, sealid, uid, parentMent);
      //   }
      // );
      // dragElement.create();
      $(parentMent).append(element);
      this.batchContactInfo.isSign = true; // 已添加印章
      this.sealListInitUsed();
      element.find(".deleteSeal").on("click", (e) => {
        this.$confirm("是否删除合同的加签", "提示", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let el = e.originalEvent.target || e.originalEvent.srcElement;
            let uid = el.dataset.uid;
            let sealid = el.dataset.sealid;
            delete this.currentItem.sealPos[sealid][uid];
            this.batchContactInfo.isSign = false; // 已删除印章
            this.sealListInitUsed();
            $(el).parent().remove();
          })
          .catch(() => {});
      });
    },
    addQFSeal(e, sealid, imgsrc, uid) {
      let _this = this;
      let x = e.offsetX || e.layerX;
      let y = e.offsetY || e.layerY;
      let firstCanvasWheight = $($(`#${this.currentItem.id} .canvasBoxFlag`)[0])
        .find(".canvasContent")
        .height();
      this.setQFPostion(
        y - this.currentMousePosition.y,
        sealid,
        uid,
        firstCanvasWheight
      );
      this.haveQfSealList.push({
        sealid: sealid,
        uid: uid,
        curInfo: this.currentItem,
      });
      sessionStorage.setItem("curFIle", JSON.stringify(this.haveQfSealList));
      Array.prototype.forEach.call(
        $(`#${this.currentItem.id} .canvasBoxFlag`),
        (value) => {
          let parentMent = $(value);
          $(value).attr("data-uid", uid);

          let canvasWidth = parentMent.find(".canvasContent").width();
          let canvasHeight = parentMent.find(".canvasContent").height();
          let element = $(
            `<div class='qifengSeal'  id="${this.currentItem.id}"  data-uid="${uid}"><div class='qifengPaddingFlag'></div> <div class='deleteSeal' data-uid="${uid}" data-sealid =${sealid}> 删除</div></div>`
          );
          element.append(
            `<img data-uid="${uid}" data-sealid =${sealid} src="${imgsrc}" draggable='false'/>`
          );
          element.addClass("sealNormal");
          element.css({
            top: y - this.currentMousePosition.y,
            left: canvasWidth,
          });
          let dragElement = new DargApi(
            element[0],
            parentMent[0],
            true,
            false,
            (x, y) => {
              $(`#${_this.currentItem.id} .qifengSeal`).css({
                top: y,
              });
              this.setQFPostion(y, sealid, uid, firstCanvasWheight);
            }
          );
          dragElement.create();
          parentMent.append(element);
          element.find(".deleteSeal").on("click", (e) => {
            let el = e.originalEvent.target || e.originalEvent.srcElement;
            let uid = el.dataset.uid;
            let sealid = el.dataset.sealid;
            delete this.currentItem.sealPos[sealid][uid];
            $(`#${_this.currentItem.id} .qifengSeal`).remove();
            this.currentItem.isAddQFSeal = false;
          });
        }
      );
    },
    handlerWrite(isDrag, uid, x, y, parentMent) {
      return; // 禁用手写签章
      this.codeValue = `${config.mobileSignUrl}/m/canvasSign?token=${
        localStorage.token || "Tnur5Z01dIINOpTFyv00y8vylkQepF"
      }`;
      // console.log(this.codeValue);
      let webSocket = new WebSockt(
        this.$sotre,
        `${config.webSocketUrl}/ws/seal/${
          localStorage.token || "Tnur5Z01dIINOpTFyv00y8vylkQepF"
        }`,
        (data, ws) => {
          this.getSealList();
          data = JSON.parse(data);
          if (data.code != 200) {
            this.$message.error("服务器问题");
          }
          if (isDrag === true && data.code == 200) {
            data = data.datas;
            let element = $(
              `<div ><div class='deleteSeal' data-uid="${uid}" data-sealid ="${data.id}" > 删除</div></div>`
            );
            element.addClass("sealNormal");
            element.css({
              top: y - this.currentMousePosition.y,
              left: x - this.currentMousePosition.x,
            });
            this.currentItem.sealPos = this.currentItem.sealPos || {};
            this.addSeal(
              element,
              parentMent,
              data.fileUrl,
              data.id,
              uid,
              x - this.currentMousePosition.x,
              y - this.currentMousePosition.y
            );
          }

          this.dialogVisible = false;
          webSocket.close();
        }
      );
      webSocket.wsAddEvent();
      this.dialogVisible = true;
    },
    drag(e) {
      console.log(e);
      // e.preventDefault(); //阻止掉浏览器的默认事件
      e.stopPropagation();
      e.preventDefault();
      switch (e.type) {
        case "dragenter":
          break;
        case "dragover":
          break;
        case "dragleave":
          break;
        case "drop":
          if (this.signTypeSingle) {
            let sealid = e.dataTransfer.getData("sealid");
            let imgsrc = e.dataTransfer.getData("imgsrc");
            let parentMent = $(e.srcElement || e.target).parent(
              ".canvasBoxFlag"
            );
            // 生成得到页面上的章唯一id
            let uid = Util.getUID();
            let x = e.offsetX || e.layerX;
            let y = e.offsetY || e.layerY;
            let isparent = true;
            if (parentMent.length) {
              isparent = true;
            } else if ($(e.srcElement || e.target).parents(".canvasBoxFlag")) {
              isparent = false;
              let parentMentNew = $(e.srcElement || e.target).parent();
              let leftP = parseInt(parentMentNew.css("left")),
                topP = parseInt(parentMentNew.css("top"));
              x = leftP;
              y = topP;
              parentMent = $(e.srcElement || e.target).parents(
                ".canvasBoxFlag"
              );
            }
            if (sealid && imgsrc) {
              let element = $(
                `<div ><div class='deleteSeal' data-uid="${uid}" data-sealid ="${sealid}"> 删除</div></div>`
              );
              element.addClass("sealNormal");
              let heights =
                document.getElementsByClassName("canvasContent")[0].height;
              let widths =
                document.getElementsByClassName("canvasContent")[0].width;
              // console.log("drop----top", y , "鼠标的位置",this.currentMousePosition.y)
              // console.log("drop----left", x ,"鼠标的位置", this.currentMousePosition.x)
              //  console.log(isparent,"isparent",parentMent,"parentMent")
              element.css({
                top:
                  y < this.currentMousePosition.y
                    ? 0
                    : heights - y < 50
                    ? heights - 119
                    : isparent
                    ? y - this.currentMousePosition.y
                    : y + this.currentMousePosition.y - 59.5,
                left:
                  x < this.currentMousePosition.x
                    ? 0
                    : widths - x < 50
                    ? widths - 119
                    : isparent
                    ? x - this.currentMousePosition.x
                    : x + this.currentMousePosition.x - 59.5,
              });
              this.currentItem.sealPos = this.currentItem.sealPos || {};
              this.addSeal(
                element,
                parentMent,
                imgsrc,
                sealid,
                uid,
                x < this.currentMousePosition.x
                  ? 0
                  : widths - x < 50
                  ? widths - 119
                  : isparent
                  ? x - this.currentMousePosition.x
                  : x + this.currentMousePosition.x - 59.5,
                y < this.currentMousePosition.y
                  ? 0
                  : heights - y < 50
                  ? heights - 119
                  : isparent
                  ? y - this.currentMousePosition.y
                  : y + this.currentMousePosition.y - 59.5
              );
            } else {
              this.handlerWrite(true, uid, x, y, parentMent);
            }
            break;
          }
      }
    },
    dragQifen(e) {
      e.preventDefault(); //阻止掉浏览器的默认事件
      switch (e.type) {
        case "dragenter":
          break;
        case "dragover":
          break;
        case "dragleave":
          break;
        case "drop":
          let sealid = e.dataTransfer.getData("sealid");
          let imgsrc = e.dataTransfer.getData("imgsrc");
          let uid = Util.getUID();
          if (!this.currentItem.isAddQFSeal) {
            this.currentItem.isAddQFSeal = true;
            if (sealid) {
              this.addQFSeal(e, sealid, imgsrc, uid);
            } else {
              this.codeValue = `${config.mobileSignUrl}/m/canvasSign?token=${
                localStorage.token || "Tnur5Z01dIINOpTFyv00y8vylkQepF"
              }`;
              let webSocket = new WebSockt(
                this.$sotre,
                `ws://${config.webSocketUrl}/ws/seal/${
                  localStorage.token || "Tnur5Z01dIINOpTFyv00y8vylkQepF"
                }`,
                (data, ws) => {
                  data = JSON.parse(data).datas;
                  this.addQFSeal(e, data.id, data.filePath, uid);
                  ws.close();
                }
              );
              this.dialogVisible = true;
              this.dialogVisible = true;
            }
          } else {
            this.$message.error("骑缝章只能上传一个");
          }
          break;
      }
    },
    // 提交
    handelConfirm() {
      if (!this.signTypeSingle && !document.querySelector(".qifengSeal")) {
        this.qfSealDialogVisible = true;
      } else {
        BaseApi.createRpcToken(
          "/contract/contractSignConfig",
          {
            contractId: this.batchContactInfo.id,
          },
          "get"
        )
          .then(
            (data) => {
              if (data.datas.signType == 0) {
                this.isUpdate = true;
                this.signtype = 1;
              } else if (data.datas.signType == 1) {
                this.isUpdate = false;
                this.signtype = 0;
              } else if (data.datas.signType == 2) {
                this.isUpdate = false;
                this.signtype = 1;
              }

              if (this.offlineSign) {
                // 线下签署
                this.confirmOfflineSignHandler();
              } else {
                this.confirmHandler();
              }
            },
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      }

      // this.confirmHandler();
    },
    // 处理签约逻辑
    confirmHandler() {
      this.signInfo = this.getSignData();
      let signCount = JSON.parse(this.signInfo.data.sealParams);
      let newFileArr = [];
      newFileArr = signCount.filter((item) => item.type == 0);
      let obj = {};
      newFileArr = newFileArr.reduce((cur, next) => {
        obj[next.fileId] ? "" : (obj[next.fileId] = true && cur.push(next));
        return cur;
      }, []);
      this.signing = true;
      // 获取二维码
      this.getFaceAuthOrderNo();
      // if (this.signInfo.hasSignCount) {
      //   if (newFileArr.length == this.fileArray.length) {
      //     if (this.signInfo.haveAuthSel) {
      //       let notSignCount =
      //         this.fileArray.length - this.signInfo.hasSignCount;
      //       if (notSignCount === 0) {
      //         if (this.codeStatus == 0) {
      //           this.signing = true;
      //         } else {
      //           this.signing = true;
      //           //获取二维码
      //           this.getFaceAuthOrderNo();
      //         }
      //       } else {
      //         this.count = notSignCount;
      //         this.$message.error(
      //           `您有文档尚未完成签署，请选择印章签署后再提交`
      //         );
      //       }
      //     } else {
      //       this.$message.error("该合同是授权合同，必须使用授权签章");
      //     }
      //   } else {
      //     this.$message.error(
      //       "如果您想使用骑缝签章，必须加盖普通签章才能进行提交。"
      //     );
      //   }
      // } else {
      //   this.$message.error("请在合同上加盖印章后，再点击提交");
      // }
    },
    // 线下签署 提交逻辑
    confirmOfflineSignHandler() {
      this.signInfo = this.getSignData();
      let isUploadAll = true; // 是否上传完 全部合同
      this.fileArray.forEach((item) => {
        if (!item.isUpload) {
          isUploadAll = false;
        }
      });
      if (!isUploadAll) {
        this.$message.error("请先上传扫描后的合同");
        return;
      }
      // 提交
      this.signing = true;
      //获取二维码
      this.getFaceAuthOrderNo();
    },

    judgeIsHaveAuthSeal() {},
    // 发起签署请求
    signRep(signInfo) {
      let list = [];
      this.batchContactList.forEach((item) => {
        if (item.isSign && item.checked && item.isSignInfo) {
          list.push({
            contractId: item.id,
            sealId: item.isSignInfo.id,
          });
        }
      });
      if (!list || !list.length) {
        this.$message.info("请选择已加签的合同");
        return;
      }
      this.isSubmitIng = true;
      this.$refs["signForm"].validate((valid) => {
        if (valid) {
          signInfo.data.signPassword = md5Util.md5(this.signForm.password);
          if (this.$route.query.isReSign) {
            signInfo.data.isReSign = true;
          }
          BaseApi.createRpcToken(
            "/contract/batchSign",
            {
              signPassword: md5Util.md5(this.signForm.password),
              sealParams: JSON.stringify(list),
            },
            "post"
          )
            .then(
              (data) => {
                if (data.code === 200) {
                  this.$message.success("正在签署" + list.length + "份协议");
                  this.$router.back();
                } else {
                  this.$message.error(data.message);
                }
              },
              () => {
                this.isSubmitIng = false;
              }
            )
            .catch(function (e) {
              errorLog(e);
            });
        } else {
          this.isSubmitIng = false;
          //签约密码输入错误
        }
      });
    },
    //处理签约的数据
    getSignData() {
      let list = [];
      this.batchContactList.forEach((item) => {
        if (item.isSign && item.checked && item.isSignInfo) {
          list.push(item);
        }
      });
      if (!list && !list.length) {
        this.$message.info("请选择已印章的合同");
        return;
      }
      let locationInfo = this.$store.getters.getLocation;
      let data = {
        id: list[0].id,
        sealParams: [],
        signLocation: locationInfo && locationInfo.location,
        signLocationAttr: locationInfo && locationInfo.LocationAttr,
      };
      //是否有授权签章变量初始化
      let haveAuthSel = true;
      if (this.sealAuthList.length) {
        haveAuthSel = false;
      }
      let hasSignCount = 0;
      // console.log(this.fileArray);
      this.fileArray.forEach((value) => {
        let hasSign = false;
        for (let i in value.sealPos) {
          if (this.sealAuthList.length) {
            this.sealAuthList.forEach((value, index) => {
              if (value.id == i) {
                haveAuthSel = true;
              }
            });
          }
          for (let x = 0; x < 2; x++) {
            let dataTemp = {
              fileId: value.id,
              sealId: i,
              sealPos: [],
              type: x,
            };
            for (let j in value.sealPos[i]) {
              hasSign = true;
              if (value.sealPos[i][j].type == x) {
                dataTemp.sealPos.push(value.sealPos[i][j]);
              }
            }
            if (dataTemp.sealPos.length) {
              data.sealParams.push(dataTemp);
            }
          }
        }
        if (hasSign) {
          hasSignCount += 1;
        }
      });
      data.sealParams = JSON.stringify(data.sealParams);
      return {
        haveAuthSel: haveAuthSel,
        hasSignCount: hasSignCount,
        data: data,
      };
    },
    handelQRcode(e) {
      this.dialogVisible = true;
    },
    closeDialog(data) {
      this.dialogVisible = data;
    },
    handelHandwriting() {
      this.isHandwriting = !this.isHandwriting;
      let path = this.$route.fullPath;
      let query = this.$route.query;
      let data = {
        isHandwriting: this.isHandwriting,
      };
      // let newQuery = this.$Method.NewQuery(query, data);
      // this.$router.push({ path: path, query: newQuery });
    },

    getContractDetail() {
      BaseApi.createRpcToken("/contract/detail", {
        id: this.batchContactInfo.id,
      })
        .then(
          (res) => {
            console.log(res, "res");
            if (res.code === 200) {
              // contractDetail->info->offlineSign
              this.contractDetail = res.datas.detail;
              this.offlineSign = res.datas.detail.info.offlineSign; // 当前用户是否为线下签署
            }
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },

    // 线下签署 上传合同完成后 需要对fileArray进行操作 pdf应打开上传成功后的文件
    resetFileArray(data) {
      $(`#${data.list[data.index].id}`).children(".canvasBoxFlag").remove(); // 移除原有的pdf
      this.$set(this.fileArray, data.index, data.list[data.index]);
      this.activeChange("", data.list[data.index]);
    },

    // 清除所有签章
    onClearSign() {
      let list = [];
      let isClearThis = false; // 是否清除当前的
      this.batchContactList.forEach((item) => {
        if (item.checked) {
          list.push({
            contractId: item.id,
            sealId: item.isSignInfo.id,
          });
          if (item.id === this.batchContactInfo.id) {
            // 当前预览的合同也被选中了，则需要对当前预览的合同进行清除加签
            isClearThis = true;
          }
        }
      });
      if (!list || !list.length) {
        this.$message.info("请选择需要清除加签的合同");
        return;
      }
      this.$confirm("是否删除合同的加签", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (isClearThis) {
            const list_d = $(".deleteSeal");
            if (list_d && list_d.length) {
              for (let i = 0; i < list_d.length; i++) {
                let el = $(list_d[i])[0];
                let uid = el.dataset.uid;
                let sealid = el.dataset.sealid;
                delete this.currentItem.sealPos[sealid][uid];

                $(el).parent().remove();
              }
            }
          }

          this.batchContactList.forEach((item) => {
            if (item.checked) {
              item.isSign = false;
            }
          });
          this.sealListInitUsed();
        })
        .catch(() => {});
    },

    // 批量签署 提交
    onBatchSignSubmit() {
      console.log(this.batchContactList);
      let list = [];
      let error = "";
      this.batchContactList.forEach((item) => {
        if (item.checked && !item.isSign) {
          error = "请对已勾选的合同进行加签";
          return;
        }
        if (item.isSign && item.checked && item.isSignInfo) {
          list.push({
            contractId: item.id,
            sealId: item.isSignInfo.id,
          });
        }
      });
      if (error) {
        this.$message.info(error);
        return;
      }
      if (!list || !list.length) {
        this.$message.info("请选择已加签的合同");
        return;
      }
      this.$confirm("是否对选择的合同进行签署", "提示", {
        confirmButtonText: "签署",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handelConfirm();
        })
        .catch(() => {});
    },
  },
  watch: {
    $route(to, from) {
      let query = to.query;
      this.isHandwriting = query.isHandwriting;
    },
    curState(data) {
      this.$router.replace("/personal/home");
    },
    confirm(val) {
      if (val) {
        BaseApi.createRpcToken(
          "/contract/contractSignConfig",
          {
            contractId: this.batchContactInfo.id,
          },
          "get"
        )
          .then(
            (data) => {
              if (data.datas.signType == 0) {
                this.isUpdate = true;
                this.signtype = 0;
              } else if (data.datas.signType == 1) {
                this.isUpdate = false;
                this.signtype = 0;
              } else if (data.datas.signType == 2) {
                this.isUpdate = false;
                this.signtype = 1;
              }

              if (this.offlineSign) {
                // 线下签署
                this.confirmOfflineSignHandler();
              } else {
                this.confirmHandler();
              }
            },
            (data) => {}
          )
          .catch(function (e) {
            errorLog(e);
          });
      }
      this.confirm = false;
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <!-- 不要加scoped 会出现问题 -->
<style lang="scss">
.sign-container {
  background-color: #eaedf1;
  width: 100%;
  padding-top: 68px;
  height: 100vh;
  box-sizing: border-box;
}

.el-input__inner:focus {
  border-color: #d81212;
  outline: 0;
}

.canvasBox {
  position: relative;
}

.success_face {
  width: 118px;
  height: 32px;
  background: rgba(174, 61, 74, 1);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: block;
  cursor: pointer;
}

.error_face {
  width: 118px;
  height: 32px;
  background: rgb(224, 224, 224);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.mySealBox_messing {
  box-sizing: border-box;
  position: absolute;
  bottom: 100px;
  left: 0px;
  width: 100%;
  color: rgb(175, 172, 172);
  font-size: 12px;
  padding-left: 20px;
}

//签署认证 start
#mySealBox {
  position: relative;
}

.dialog_header {
  width: 70%;
  margin: 0 auto;
  display: flex;
  border-bottom: 1px solid #ccc;
  height: 40px;
  align-items: center;
  margin-top: 20px;
  box-sizing: border-box;

  p {
    width: 50%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    // border-bottom: 1px solid #ccc;
    font-weight: 600;
    box-sizing: border-box;
    cursor: pointer;
  }

  p.active {
    border-bottom: 2px solid #d81212;
    color: #d81212;
  }
}

.rlsb {
  width: 100%;
  height: 300px;
  position: relative;

  .erweima_errro {
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left: -80px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;

    .error_title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      margin-bottom: 12px;
    }

    .update_erweima {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000;
      cursor: pointer;
    }
  }

  .erweima_success {
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left: -80px;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;

    .success_desc {
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }

    .success_title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      margin-top: 15px;
    }

    .success_update_erweima {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(77, 175, 247, 1);
      cursor: pointer;
    }

    img {
      opacity: 1;
    }
  }

  .rlsb_title {
    color: #1890ff;
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890ff;
      border: 0;
    }
  }

  .erweima {
    width: 160px;
    margin: 0 auto;
    height: 160px;

    img {
      width: 100%;
    }
  }

  .rlsb_desc {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    // margin-top: 20px;
  }
}

//签署认证 end
.signDialog {
  height: 200px;
  width: 400px;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;

  .authDscp {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }

  .withInput {
    width: 100%;
    text-align: left;

    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
}

.pagingSeal-btn {
  cursor: pointer;
  width: 32px;
  padding: 15px 0;
  text-align: center;
  line-height: 32px;
  letter-spacing: 3px;
  font-size: 16px;
  writing-mode: vertical-rl;
  border-radius: 0 15px 15px 0;
  transition: all 0.3s;
  background: #4a90e2;
  border-radius: 15px;
  color: #fff;
  margin-left: 13px;
}

.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background: #fff;
  border-color: #d81212;
  color: #d81212;
}

.el-button--danger.is-plain {
  color: #db4437;
  background: #fff;
  border-color: #db4437;
}

.sealNormal {
  position: absolute;
  width: 119px;
  height: 119px;
  touch-action: none;
  background-color: rgba(208, 2, 27, 0.08);
  z-index: 4;

  img {
    width: 119px;
    height: 119px;
  }

  .deleteSeal {
    position: absolute;
    display: none;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    line-height: 12px;
    text-align: center;
    width: 40px;
    height: 20px;
    z-index: 2;
    line-height: 20px;
    background: rgba(208, 2, 27, 0.6);
    opacity: 1;
    border-radius: 0 0 10px 10px;
    cursor: pointer;
    border: none;
    left: 50%;
    top: 118px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  &:hover {
    .deleteSeal {
      display: block;
    }
  }
}

.seal-tip-normal {
  position: absolute;
  width: 119px;
  height: 119px;
  touch-action: none;
  background-color: rgba(208, 2, 27, 0.08);
  z-index: 4;
  text-align: center;
  line-height: 119px;
  color: #db1c1b;
}

.el-button--danger.is-plain:focus,
.el-button--danger.is-plain:hover {
  background: #e25364 !important;
  border-color: #e25364 !important;
  color: #fff !important;
}

.el-button--danger:focus,
.el-button--danger:hover {
  background: #e25364;
  border-color: #e25364;
  color: #fff;
}

.el-button--danger {
  color: #fff;
  background-color: #d81212;
  border-color: #d81212;
}

.el-button {
  // padding: 0 0;
}

.el-input__inner {
  height: 100%;
  line-height: 30px;
  border-radius: 0px;
}

.pdfPage {
  position: absolute;
  top: 24px;
  right: 24px;
  padding: 3px 16px;
  font-size: 18px;
  font-weight: 200;
  color: #fff;
  line-height: 25px;
  border-radius: 8px;
  background: #9b9b9b;
}

.qifenDong {
  position: absolute;
  top: 0;
  right: -1px;
  width: 120px;
  height: 100%;
  border-radius: 0 14px 14px 0;
  background: #fff;
  z-index: 2;
  transition: all 0.3s;
  background: url(../../../../../assets/images/personalSign/qifengSealBg.png)
    no-repeat 100%;
  background-size: 100% 100%;
}

.pagingSeal-transition {
  transform: translateX(120px);
}

.sealFlagQifeng {
}

.qifengSealMove {
  transform: translateX(-23px);

  &:hover {
    .deleteSeal {
      display: none;
    }
  }
}

.qifengPadding {
  position: absolute;
  top: 0;
  left: 30px;
  z-index: 3;
  width: 89px;
  height: 119px;
  -webkit-transition: width 0.3s;
  transition: width 0.3s;
  background: #e4e9ee;
}

.signing {
  .input {
    display: inline-block;
    width: 160px;
    height: 30px;

    .el-input__inner {
      height: 100%;
      line-height: 30px;
      border-radius: 0px;
    }
  }
}
</style>
  
  <style lang="scss">
.handwritingModal {
  width: 500px;
  height: 410px;

  .scanning {
    color: #646464;
    text-align: center;
    margin-top: 18px;
  }

  .effective {
    color: #4daff7;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 10px;
  }

  #canvas {
    margin: 0 auto;
    width: 200px !important;
    height: 200px !important;
    display: block;
    padding-left: 46px;
  }

  .warning {
    margin-top: 40px;
    padding: 0 40px;
    text-align: justify;
    line-height: 20px;
    color: #000;

    i {
      font-style: normal;
      color: #e88078;
    }
  }
}

.newDialog {
  width: 500px;
  padding-bottom: 10px;

  .scanning {
    color: #646464;
    text-align: center;
    margin-top: 18px;
  }

  .effective {
    color: #646464;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .footer {
    text-align: center;
  }

  .el-button {
    width: 80px;
    height: 30px;
  }
}

.signature {
  padding: 20px;
  position: relative;
  &.signature2 {
    padding: 0 !important;
    width: 1350px;
    overflow: auto;
    background-color: #fff;
    margin: 0 auto;
    box-sizing: border-box;
    height: calc(100% - 70px);
  }
  .forgetPassword {
    width: 450px;
    height: 290px;

    .content {
      width: 450px;
      height: 220px;
      overflow: hidden;
      padding-top: 30px;

      .leftPass {
        width: 160px;
        height: 220px;

        span {
          i {
            color: #db4437;
          }

          display: block;
          text-align: right;
          height: 50px;
          line-height: 30px;
        }
      }

      .rightPass {
        width: 290px;
        height: 220px;

        .passwordInput {
          height: 50px;

          .getCode {
            color: #70c8e5;
            margin-left: 6px;
          }

          .errorMessage {
            color: #db4437;
          }
        }

        .input {
          width: 200px;
          height: 30px;
        }
      }
    }

    .foot {
      text-align: center;

      .can {
        width: 100px;
        height: 32px;
      }
    }
  }

  .cancel {
    margin-top: 54px;
    padding-bottom: 30px;
    text-align: center;

    .can {
      width: 100px;
      height: 32px;
    }

    .sure {
      width: 100px;
      height: 32px;
    }
  }

  .password {
    text-align: center;
    padding-left: 44px;
    margin-top: 54px;
    color: #919191;

    .el-form-item__content {
      text-align: left;
    }

    .forget {
      margin-left: 6px;
      text-decoration: none;
      border-bottom: 1px solid #ccc;
      display: inline-block;
      padding-bottom: 1px;
      line-height: 20px;
      cursor: pointer;
    }
  }

  .mainContainer {
    // width: calc(100% - 40px);
    height: 100%;
    &.mainContainer2 {
      width: 100% !important;
      height: 100% !important;
    }
    .header {
      width: 100%;
      height: 36px;
      line-height: 36px;
      border-bottom: 1px solid #e4e8eb;

      span {
        display: inline-block;
        color: #787878;
      }

      span:nth-of-type(2) {
        margin-left: 20px;
      }

      span:nth-of-type(4) {
        color: #e88078;
      }

      .leftBar {
        width: 4px;
        height: 20px;
        background: #e88078;
        border-radius: 4px;
        position: relative;
        top: 3px;
      }
    }

    .content {
      width: 100%;
      // height: 100%;
      overflow: hidden;
      height: calc(100% - 128px);
      margin-top: 20px;
      display: flex;
      &.content2 {
        margin-top: 0 !important;
        height: 100% !important;
      }

      .left {
        width: 292px;
        height: 99%;
        border: 1px solid #e4e8eb;
        &.left2 {
          width: 167px !important;
          height: 100% !important;
          border: none !important;
          border-right: 8px solid #eaedf1 !important;
          min-height: 100vh !important;
        }
        .handwritingCon {
          width: 292px;
          height: calc(100% - 48px);
          overflow-y: auto;
          // height: 100%;
          &.handwritingCon2 {
            width: 167px !important;
            height: calc(100% - 253px) !important;
            padding: 0 0 15px 0;
            box-sizing: border-box;
          }
          .sign {
            width: 137px;
            height: 137px;
            border: 1px solid #e9e9e9;
            margin-left: 15px;
            margin-top: 22px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .sign-button {
              display: none;
            }
            &:hover {
              box-shadow: 0 0 8px #f7c9c8;
              .sign-button {
                display: block;
                width: 137px;
                height: 28px;
                background: #505050;
                position: absolute;
                left: 0;
                bottom: 0;
                line-height: 28px;
                text-align: center;
                color: #ffffff;
                font-size: 15px;
                cursor: pointer;
              }
            }
          }

          .addSign {
            border: 1px dashed #e4e8eb;

            .nor {
              display: block;
            }

            .hov {
              display: none;
            }

            &:hover {
              .nor {
                display: none;
              }

              .hov {
                display: block;
              }
            }
          }
        }

        .noSeal {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #909399;
          font-size: 12px;
          padding-top: 20px;
        }

        .tabSign {
          width: 292px;
          height: 48px;
          border-bottom: 1px solid #e4e8eb;

          .handwritings {
            display: inline-block;
            text-align: center;
            color: #646464;
            line-height: 48px;
            width: 146px;
            height: 48px;
            position: relative;

            // margin-left:74px;
            .underLine {
              width: 64px;
              height: 3px;
              background: #e88078;
              display: inline-block;
              position: absolute;
              bottom: -1px;
              left: 41px;
            }
          }
        }
      }

      .right {
        flex: 1;
        width: calc(100% - 306px);
        height: 99%;
        margin-left: 10px;
        border: none;
        padding: 15px;
        &.right2 {
          width: 100% !important;
          margin-left: 0 !important;
        }
      }
    }
  }
}

.tabContainerSignC {
  height: 100%;
  position: relative;

  .moreSign {
    &:hover {
      .allSignContainer {
        display: block;
      }
    }
  }

  .allSignContainer {
    display: none;
    position: absolute;
    top: 33px;
    z-index: 10;
    width: 100%;

    .allSign {
      opacity: 0.8;
      background: #ffffff;
      border: 1px solid #e4e8eb;
      padding-top: 10px;

      .allSignItem {
        display: inline-block;
        cursor: pointer;
        width: 132px;
        font-size: 12px;
        line-height: 32px;
        padding: 0 20px;

        &:hover {
          color: #e88078;
        }
      }
    }
  }

  .selectMore {
    position: absolute;
    cursor: pointer;
    width: 100px;
    height: 30px;
    line-height: 32px;
    right: 0;
    top: 0;
    border: 1px solid #e29999;
    font-size: 12px;
    color: #e29999;
    text-align: center;
    z-index: 2;
  }

  .el-tabs__header {
    max-width: calc(100% - 120px);
  }

  .el-tabs__nav-next,
  .el-tabs__nav-prev {
    line-height: 33px;
  }

  .el-tabs {
    height: 100%;
  }

  .el-tabs__item {
    height: 33px;
    line-height: 30px;
    font-size: 12px;
    color: #646464;
    background: #f5f5f5;
    border-top: 3px solid #f5f5f5;
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__item:hover {
    color: #e88078;
  }

  .el-tabs--card > .el-tabs__header {
    border-bottom: 1px solid #e4e8eb;
  }

  .el-tabs__item.is-active {
    color: #e88078;
    background-color: #ffffff;
    border-top: 3px solid #e88078;
  }

  .flowContainer {
    height: 100%;
    box-sizing: border-box;
    padding-top: 50px;
  }

  .performContainer {
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 20px;
    padding-top: 10px;
    overflow-y: auto;
  }

  .page {
    position: fixed;
    right: 50px;
    width: 60px;
    height: 190px;
    text-align: center;
    bottom: 120px;
    z-index: 20;

    span {
      margin-top: 6px;
      display: block;
    }

    .up {
      img {
        margin: 0 auto;
      }

      .nor {
        display: block;
      }

      .hov {
        display: none;
      }

      &:hover {
        .nor {
          display: none;
        }

        .hov {
          display: block;
        }
      }
    }
  }

  .page-handle {
    position: fixed;
    right: 50px;
    text-align: center;
    bottom: 120px;
    z-index: 20;
    .handle-box {
      display: flex;
      align-items: center;
      font-size: 11px;
      color: #bdbdbd;
      margin-bottom: 9px;
      .handle-label {
        width: 45px;
        &.handle-label-red {
          color: #db1c1b;
        }
      }
    }
    .handle-view {
      width: 26px;
      height: 26px;
      background: #bdbdbd;
      text-align: center;
      line-height: 26px;
      border-radius: 50%;
      cursor: pointer;
      margin-left: 4px;
      i {
        color: #ffffff;
        font-size: 12px;
      }
      &.right-handle {
        background: #db1c1b;
      }
    }
  }

  .el-tabs__content {
    box-sizing: border-box;
    border: 1px solid #e4e8eb;
    border-top: none;
    padding: 10px;
    height: calc(100% - 48px);
    background: #e3e9ef;
    // overflow: auto;
    width: 100%;
    position: relative;

    .el-tab-pane {
      height: 100%;

      .pdfCon {
        box-sizing: border-box;
        height: calc(100% - 10px);
        margin: 0 auto;
        margin-top: 10px;
        overflow: auto;
      }
    }
  }
}

.masks {
  position: absolute;
  z-index: 99999;
  width: 300px;
  height: 38px;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  left: 50%;
  margin-left: -150px;
  top: 50%;
  margin-top: -25px;
  box-sizing: border-box;
  line-height: 38px;
  font-size: 14px;
  animation: fadeInOut 0.5s;
}

/*定义公共淡入淡出效果 fadenum*/
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.batch-file-list {
  width: 261px;
  background-color: #ffffff;
  border-right: 8px solid #eaedf1;
  padding: 15px 11px;
  box-sizing: border-box;
  font-family: PingFangSC-Medium, PingFang SC;
  .batch-list-title {
    height: 15px;
    font-size: 15px;
    font-weight: bold;
    color: #505050;
    line-height: 15px;
    margin-bottom: 15px;
  }

  .file-list-box {
    height: 100%;
    overflow: auto;
    .file-list {
      .file-item {
        display: flex;
        // align-items: center;
        margin-bottom: 23px;
        .file-name {
          flex: 1;
          display: flex;
          // align-items: center;
          font-size: 13px;
          line-height: 15px;
          .file-name-text {
            margin-left: 8px;
            flex: 1;
            cursor: pointer;
          }

          .add-tag {
            padding: 2px;
            height: 15px;
            line-height: 11px;
            color: #f6bf31;
            background: #f4efc9;
            font-size: 10px;
            text-align: center;
            border-radius: 4px;
            box-sizing: border-box;
          }
        }
        .file-number {
          color: #bdbdbd;
          line-height: 15px;
          font-size: 10px;
        }
      }
      .flie-item-indent {
        padding-left: 22px;
      }
      .flie-item-indent2 {
        padding-left: 44px;
      }
      .file-item-active {
        .file-name {
          .file-name-text {
            color: #db1c1b;
          }
        }
      }
    }
  }
}

.seal-title {
  display: flex;
  align-items: center;
  font-family: PingFangSC-Medium, PingFang SC;
  padding: 15px 11px;
  .seal-title-text {
    height: 15px;
    font-size: 15px;
    font-weight: bold;
    color: #505050;
    line-height: 15px;
  }
  .seal-title-number {
    width: 30px;
    height: 15px;
    font-size: 11px;
    font-weight: 400;
    color: #bdbdbd;
    line-height: 15px;
    flex: 1;
    text-align: right;
  }
}

.seal-intro {
  line-height: 23px;
  font-size: 13px;
  color: #bdbdbd;
  padding: 0 11px;
}
</style>

<style lang="scss" scoped>
.personalMainHead {
  width: 100%;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
}

.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 60px;
  background-color: #ffffff;
  line-height: 60px;
  text-align: center;
  z-index: 10;
  .ret {
    width: 100px;
    height: 32px;
  }

  .btn {
    width: 100px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    padding: 0;
  }
  .saveBtn {
    border: 1px solid #e9e9e9;
    background: #ffffff;
    color: #bdbdbd;
  }
  .submitBtn {
    color: #ffffff;
    background: #db1c1b;
  }

  .absolute-button {
    position: absolute;
    left: 24px;
    top: 17px;
    color: #db1c1b;
  }
}
</style>